@if (canGetReceipt) {
  <div>
    <a class="title" color="primary" (click)="displayTicket()">{{ "RECEIPT.TITLE" | transloco }}</a>
  </div>
}
